<template>
  <div
    class="initial-dialog-root
      phone:m-0! phone:h-dvh! phone:w-screen! phone:max-h-[100dvh]! phone:max-w-[100vw]! phone:overflow-hidden!"
  >
    <section
      class="initial-dialog relative flex w-90 flex-col items-center rounded-24 bg-bg-base-bg2 shadow-overlay
        phone:h-full phone:min-h-full phone:w-full phone:max-w-none phone:rounded-none phone:shadow-none"
    >
      <div
        class="flex w-full flex-col items-center px-5 pt-10 pb-5
          phone:grow phone:justify-center phone:pt-16 phone:pb-8"
      >
        <p class="text-heading-sb-18-24 text-fg-base-fg3 text-center phone:text-2432">
          {{ $t('common.outgoingCall') }}: {{ $t('common.connection') }} ...
        </p>
        <p class="mt-6 text-2432 text-center">
          {{ $t('common.dialingNumber') }} ...
        </p>
        <dots-loader class="mt-4 mb-4" />
      </div>

      <footer
        class="flex w-full shrink-0 gap-3 px-5 pb-7 pt-2
          phone:px-6 phone:pb-10"
      >
        <wui-btn
          variant="negative"
          state="filled"
          class="h-15! w-full rounded-16! text-heading-m-16-22"
          data-test="initial-dialog-cancel-button"
          @click="cancel"
        >
          {{ $t('common.end') }}
        </wui-btn>
      </footer>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { closeDialogKey, safeInject, WuiBtn } from '@wui/common-library'

import { RTCSessionFacade } from '@/entities/webrtc'

import { DotsLoader } from '@/shared/components/loaders'

const props = defineProps<{
  rtcSessionFacade: RTCSessionFacade
}>()

const closeDialog = safeInject(closeDialogKey)

const cancel = () => {
  closeDialog(true)
  props.rtcSessionFacade.terminate()
}
</script>

<style>
@media (max-width: 501px) {
  .wui-modal-overlay:has(.initial-dialog-root) {
    align-items: stretch;
    justify-content: stretch;
    padding: 0;
  }

  .wui-dialog__panel:has(.initial-dialog-root) {
    display: flex;
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    max-height: none !important;
    margin: 0 !important;
    flex: 1 1 auto;
  }

  .initial-dialog-root {
    display: flex;
    flex: 1 1 auto;
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    max-height: none !important;
    margin: 0 !important;
    overflow: hidden !important;
  }

  .initial-dialog-root > .initial-dialog {
    flex: 1 1 auto;
    width: 100% !important;
    max-width: none !important;
  }
}
</style>
